import { useState, useEffect } from "react";
import db from "../../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import QrWAcode from "../contact/QrWAcode";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    age: "",
    suggestion: "",
  });

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [isValid, setIsValid] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Run validation live for this field
    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
  };

  // ✅ Field-wise validation
  const validateField = (field, value) => {
    switch (field) {
      case "name":
        if (!value.trim()) return "Name is required";
        if (!/^[a-zA-Z ]{2,30}$/.test(value)) return "Enter a valid name";
        break;
      case "suggestion":
        if (!value.trim()) return "give your suggestion/feedback";
        if (!/^[a-zA-Z ]{2,30}$/.test(value)) return "Enter a valid name";
        break;
      case "email":
        if (!value.trim()) return "Email is required";
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value))
          return "Invalid email address";
        break;
      case "age":
        if (!value) return "Age is required";
        if (value < 9 || value > 100) return "Age must be between 9 and 100";
        break;
      default:
        return "";
    }
    return "";
  };

  // ✅ Overall validation check (runs whenever formData or errors change)
  useEffect(() => {
    const noErrors = Object.values(errors).every((err) => err === "");
    const allFilled = Object.values(formData).every((val) => val !== "");
    setIsValid(noErrors && allFilled);
  }, [errors, formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Final validation before submit
    const newErrors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      // ✅ Save to Firestore
      await addDoc(collection(db, "contacts"), {
        ...formData,
        createdAt: Timestamp.now(),
      });

      setSuccessMsg("Your details submitted successfully ✅");
      setTimeout(() => setSuccessMsg(""), 3000);

      // Reset form
      setFormData({ name: "", suggestion: "", email: "", age: "" });
      setErrors({});
    } catch (error) {
      console.error("Error saving contact:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="contact-container">
        {/* Glass Form */}
        
        <div className="contact-form-wrapper">
          <h2 className="shorts-heading" data-aos="fade-in">Contact Us</h2>
          <form className="contact-form" data-aos="fade-in" onSubmit={handleSubmit}>
            <input type="text" placeholder="Your Name" name="name" value={formData.name} onChange={handleChange} />
            {errors.name && <span className="error">{errors.name}</span>}
{/* 
            <input type="text" placeholder="Phone Number" name="phone" value={formData.phone} onChange={handleChange} />
            {errors.phone && <span className="error">{errors.phone}</span>} */}

            <input type="email" placeholder="Your Email" name="email" value={formData.email} onChange={handleChange} />
            {errors.email && <span className="error">{errors.email}</span>}

            <input type="number" placeholder="Your Age" name="age" value={formData.age} onChange={handleChange} />
            {errors.age && <span className="error">{errors.age}</span>}

            <input type="text" placeholder="suggestion/feedback" name="suggestion" value={formData.suggestion} onChange={handleChange} />
            {errors.suggestion && <span className="error">{errors.suggestion}</span>}

            <button type="submit" disabled={!isValid} className={!isValid ? "submit-btn disabled" : "submit-btn"}>
              Submit
            </button>

            {successMsg && <p className="success success-toast">{successMsg}</p>}
          </form>
        </div>
        {/* <div className="contact-side-text">
          <span>Let's Connect!</span>
          <p className="text-dark">Fill in your details and submit. We will send you daily Hadith, Tamseel short clips, and event updates on WhatsApp. Additionally, we will share our magazine with you via email.</p>
        </div> */}

        {/* Animated Text Section */}
        <QrWAcode />        
      </div>

    </>
  );
};

export default Contact;
